export const CHANGELOG_ACTION_LABELS: Record<string, string> = {
  'customer.autologin.customer' : 'Autologin customer',
  'customer.autologin.discipline' : 'Autologin discipline',
  'customer.autologin.child' : 'Autologin child',
  'customer.autologin.campaign' : 'Autologin campaign for customer',

  'customer.discipline.lesson' : 'Discipline lesson page',
  'customer.lesson.show' : 'Lesson was showed',
  'customer.lesson.update' : 'Lesson was updated',
  'customer.lesson.ping' : 'Ping lesson (check status)',
  'customer.lesson.index' : 'List of all lessons',

  'customer.enroll' : 'Customer enrollment page',

  'customer.orders.index' : 'Customer orders page was showed',
  'customer.orders.list' : 'List of customer orders was showed',
  'customer.orders.refund' : 'Refund order was sent',
  'customer.orders.get-invoice' : 'Get order invoice',
  'customer.orders.mark-trial' : 'Mark order as trial',
  'customer.orders.create' : 'Create new order',
  'customer.subscriptions.create' : 'Create new subscription',
  'customer.orders.show' : 'Show order details',
  'customer.orders.upsell' : 'Upsell page after order',
  'customer.orders.details' : 'Detailed order page',

  'customer.orders.checkout' : 'Checkout page',
  'customer.orders.apply-promocode' : 'Apply promocode',
  'customer.orders.apply-credits' : 'Apply credits',
  'customer.orders.process-zero' : 'Process zero-amount order',
  'customer.orders.change-discount-method' : 'Change discount method',

  'customer.payments.create' : 'Payment for order was created',
  'customer.subscriptions.resubscribe' : 'Resubscribe subscription',
  'customer.payments.quick-pay' : 'Quick pay for order',

  'customer.otp.send' : 'Send OTP to customer',
  'customer.otp.verify' : 'Verify OTP',

  'customer.home.index' : 'Customer homepage was viewed',
  'customer.home.contact-me' : 'Contact form submission',

  'customer.activation.store' : 'Customer activation',

  'customer.discipline.settings.index' : 'Discipline settings',
  'customer.discipline.settings.show' : 'View discipline settings',
  'customer.discipline.settings.store' : 'Save discipline settings',

  'customer.settings.index' : 'Customer settings page',
  'customer.settings.show' : 'View specific customer setting',
  'customer.settings.store' : 'Save customer settings',

  'customer.bookings.search' : 'Search bookings',
  'customer.bookings.schedule' : 'Schedule new booking',
  'customer.bookings.reschedule' : 'Reschedule booking',
  'customer.bookings.cancel' : 'Cancel booking',
  'customer.bookings.available-slots' : 'Available booking slots',
  'customer.bookings.available-slots-for-booking' : 'Available slots for specific booking',

  'customer.bookings.recording.download' : 'Download lesson recording',

  'customer.account.update' : 'Customer profile was updated',
  'customer.account.profile' : 'Customer profile page was viewed',
  'customer.share.discipline-lesson-link' : 'Share discipline lesson link',

  'customer.logout' : 'Customer logout',

  'customer.pricing.index' : 'Pricing page was showed',
  'customer.pricing.contact' : 'After demo callback was sent',
  'customer.pricing-ela.index' : 'ELA pricing page was showed',

  'customer.pad.index' : 'PAD page was showed',
  'customer.pad-ela.index' : 'PAD ELA page was showed',

  'customer.skill-report.index' : 'Skill report page was showed',

  'customer.files.index' : 'Customer file packs list was showed',
  'customer.files.pack.create' : 'Create new file pack',
  'customer.files.search' : 'Search files',
  'customer.files.show' : 'View file pack',
  'customer.files.pack.send' : 'Send file pack',
  'customer.files.pack.delete' : 'Delete file pack',
  'customer.files.upload' : 'Upload file',
  'customer.files.delete' : 'Delete file',
  'customer.files.download' : 'Download file via signed URL',
  'customer.files.view' : 'View file via signed URL',

  'customer.push.store' : 'Create push notification',

  'customer.payment-methods.stripe.index' : 'Stripe payment methods list',
  'customer.payment-methods.stripe.add' : 'Add Stripe payment method',
  'customer.payment-methods.stripe.default' : 'Set default Stripe payment method',
  'customer.payment-methods.stripe.remove' : 'Remove Stripe payment method',

  'customer.payment-methods.solidgate.index' : 'Solidgate payment methods list',
  'customer.payment-methods.solidgate.add' : 'Add Solidgate payment method',
  'customer.payment-methods.solidgate.default' : 'Set default Solidgate payment method',
  'customer.payment-methods.solidgate.remove' : 'Remove Solidgate payment method',

  'customer.surveys.store' : 'Submit survey response',

  'customer.assessments.index' : 'Assessments list was showed',
  'customer.assessments.store' : 'Assessment was created',
  'customer.assessments.show' : 'Assessment was viewed',

  'customer.rebook.store' : 'Rebook lesson was send',

  'customer.subscriptions.failed' : 'Failed subscriptions page',
  'customer.subscriptions.pause' : 'Pause subscription',
  'customer.subscriptions.resume' : 'Resume subscription',
  'customer.subscriptions.cancel' : 'Cancel subscription',
  'customer.subscriptions.cancellation-offer' : 'Cancellation offer',
  'customer.subscriptions.retry' : 'Retry subscription payment',

  'customer.landing-math.index' : 'Math landing page was showed',
  'customer.landing-ela.index' : 'ELA landing page was showed',
  'customer.landing.available-slots' : 'Available slots for demo lesson',
  'customer.landing.demo-book' : 'Book demo lesson',

  'customer.discipline.tutor.change' : 'Tutor on CS was changed',

  'customer.payments.index' : 'Payments page was showed',
  'customer.payments.methods' : 'Payment methods page was showed',
  'customer.payments.history' : 'Payment history was showed',
  'customer.payments.subscriptions' : 'Subscriptions page was showed',

  'customer.account.payment-methods' : 'Payment methods page on account was showed',
  'customer.account.payment-history' : 'Payment history page on account was showed',
  'customer.account.subscriptions' : 'Subscriptions page on account was showed',

  'admin.register' : 'Register admin user',
  'admin.login' : 'Admin login',
  'admin.password.request' : 'Request password reset',
  'admin.password.email' : 'Send password reset email',
  'password.reset' : 'Reset password (user-facing)',
  'admin.password.reset' : 'Reset admin password',
  'admin.welcome' : 'Admin welcome page',

  'verification.notice' : 'Email verification notice',
  'verification.verify' : 'Verify email',
  'verification.send' : 'Send email verification notification',
  'password.confirm' : 'Confirm password',
  'admin.logout' : 'Admin logout',

  'admin.dashboard' : 'Admin dashboard',

  'admin.customers.index' : 'List customers',
  'admin.customers.store' : 'Customer was created',
  'admin.customers.show' : 'Customer page was showed',
  'admin.customers.details' : 'Customer details was showed',
  'admin.customers.update' : 'Customer was updated',
  'admin.customers.crm-pull' : 'Pull customer from CRM',
  'admin.customers.crm-push' : 'Push customer to CRM',
  'admin.customers.delete' : 'Customer was deleted',
  'admin.customers.behalf' : 'Customer act on behalf',
  'admin.customers.statuses-and-sources' : 'Customer statuses and sources was showed',
  'admin.customers.send-reload' : 'Send reload to customer',
  'admin.customers.comments' : 'Customer comments was showed',
  'admin.customers.respond-push' : 'Push to Respond',

  'admin.customers.credits.index' : 'Customer credits page was showed',
  'admin.customers.credits.add' : 'Customer credits were added',
  'admin.customers.credits.remove' : 'Customer credits were removed',

  'admin.customers.subscriptions.index' : 'List customer subscriptions was showed',

  'admin.subscriptions.index' : 'List subscriptions was showed',
  'admin.subscriptions.update' : 'Subscription was updated',
  'admin.subscriptions.sync' : 'Sync subscription',
  'admin.subscriptions.pause' : 'Subscription was paused',
  'admin.subscriptions.resume' : 'Subscription was resumed',
  'admin.subscriptions.cancel' : 'Subscription was canceled',
  'admin.subscriptions.available-products' : 'Available products for subscription',
  'admin.subscriptions.update-products' : 'Subscription product was updated',
  'admin.subscriptions.send-upsell' : 'Send subscription upsell',
  'admin.subscriptions.get-split-details' : 'Get subscription split details',
  'admin.subscriptions.apply-split' : 'Apply subscription split',
  'admin.subscriptions.apply-discount' : 'Apply subscription discount',

  'admin.customers.orders' : 'List customer orders',

  'admin.disciplines.orders.create' : 'Discipline order was created',
  'admin.disciplines.orders.calculate' : 'Calculate discipline order',
  'admin.disciplines.subscriptions.calculate' : 'Calculate discipline subscription',
  'admin.disciplines.orders.store' : 'Generate discipline order',
  'admin.disciplines.subscriptions.store' : 'Generate discipline subscription',

  'admin.disciplines.show' : 'Show discipline',
  'admin.disciplines.details' : 'Discipline details',
  'admin.disciplines.report' : 'Discipline report',
  'admin.disciplines.stage-comments' : 'Discipline stage comments',
  'admin.disciplines.stage-logs' : 'Discipline stage logs',
  'admin.disciplines.activation' : 'Discipline activation',
  'admin.disciplines.store' : 'Discipline was created',
  'admin.disciplines.duplicate' : 'Duplicate discipline',
  'admin.disciplines.update' : 'Discipline was updated',
  'admin.disciplines.delete' : 'Delete discipline',
  'admin.disciplines.send-enroll' : 'Send enroll for discipline',
  'admin.disciplines.merge-profiles' : 'Merge discipline profiles',

  'admin.disciplines.schedule.tutor-availability' : 'Get tutor week availability',
  'admin.disciplines.schedule.update' : 'Discipline schedule was updated',

  'admin.discipline-lessons.index' : 'List discipline lessons',
  'admin.discipline-lessons.store' : 'Discipline lesson was created',
  'admin.discipline-lessons.check-schedule' : 'Check tutor schedule',
  'admin.discipline-lessons.recurring' : 'Recurring lessons was created',
  'admin.discipline-lessons.show' : 'Show discipline lesson',
  'admin.discipline-lessons.update' : 'Discipline lesson was updated',
  'admin.discipline-lessons.reschedule' : 'Reschedule discipline lesson',
  'admin.discipline-lessons.delete' : 'Delete discipline lesson',
  'admin.discipline-lessons.move-later' : 'Move lessons later',
  'admin.discipline-lessons.bulk-update' : 'Bulk discipline lessons was updated',
  'admin.discipline-lessons.bulk-delete' : 'Bulk delete discipline lessons',
  'admin.discipline-lessons.approve-join' : 'Approve join for discipline lesson',

  'admin.discipline-balances.index' : 'List discipline balances',
  'admin.discipline-balances.store' : 'Discipline balance was created',

  'admin.discipline-files.index' : 'List discipline files',
  'admin.discipline-files.show' : 'Show file pack',
  'admin.discipline-files.create-pack' : 'File pack was created',
  'admin.discipline-files.edit-pack' : 'Edit file pack',
  'admin.discipline-lessons.certificate' : 'Generate lesson certificate',
  'admin.discipline-files.send' : 'File on admin area was sent',
  'admin.discipline-files.upload' : 'File on admin area was uploaded',
  'admin.discipline-files.delete' : 'File on admin area was deleted',
  'admin.discipline-files.delete-pack' : 'File pack on admin area was deleted',

  'admin.discipline-surveys.index' : 'List discipline surveys',

  'admin.discipline-progress-reports.index' : 'List discipline progress reports',

  'admin.discipline-tasks.index' : 'List discipline tasks',

  'admin.surveys.index' : 'List surveys',
  'admin.surveys.export' : 'Export surveys',

  'admin.bookings.sync-google-event' : 'Sync booking with Google Calendar',

  'admin.demo-lessons.index' : 'Demo Lessons',
  'admin.attendance-setter.index' : 'Attendance setter',
  'admin.attendance-setter.update' : 'Demo lesson was updated',
  'admin.attendance-setter.refresh-lesson-room' : 'Refresh demo lesson room',

  'admin.demo-sale.lessons.index' : 'List demo-sale lessons',
  'admin.demo-sale.lessons.log' : 'Log of demo-sale lessons',
  'admin.demo-sale.lessons.update' : 'Demo-sale lesson was updated',

  'admin.demo-sale.agents.index' : 'List demo-sale agents',
  'admin.demo-sale.agents.availability' : 'Set demo-sale agent availability',
  'admin.demo-sale.agents.update' : 'Demo-sale agents was updated',
  'admin.demo-sale.agents.clear-priority' : 'Clear demo-sale agent priority',

  'admin.demo-sale.agents-log.index' : 'View demo-sale agents log',

  'admin.paid-lessons.index' : 'List paid lessons',
  'admin.paid-lessons.export' : 'Export paid lessons',
  'admin.paid-lessons.update' : 'Paid lesson was updated',
  'admin.paid-lessons.delete' : 'Delete paid lesson',

  'admin.demo-slots-management.index' : 'View demo slots management',
  'admin.demo-slots-management.update' : 'Demo slots management was updated',

  'admin.sales-queue-slots-management.index' : 'View sales queue slots management',
  'admin.sales-queue-slots-management.update' : 'Sales queue slots management was updated',

  'admin.demo-slots-coefficients.index' : 'View demo slots coefficients',
  'admin.demo-slots-coefficients.update' : 'Demo slots coefficients was updated',

  'admin.tutors.index' : 'List tutors',
  'admin.tutors.create' : 'Tutor was created',
  'admin.tutors.store' : 'Tutor created',
  'admin.tutors.tutor-availability' : 'Set individual tutor availability',
  'admin.tutors.availability' : 'Set tutors availability',
  'admin.tutors.show' : 'Show tutor',
  'admin.tutors.additional-info' : 'View tutor additional info',
  'admin.tutors.update' : 'Tutor was updated',
  'admin.tutors.update-avatar' : 'Tutor avatar was updated',
  'admin.tutors.update-password' : 'Tutor password on admin area was updated',
  'admin.tutors.delete' : 'Delete tutor',

  'admin.tutor-attendance-rates.index' : 'View tutor attendance rates',

  'admin.tutors.schedule.show' : 'Show tutor schedule',
  'admin.tutors.schedule.update' : 'Tutor schedule was updated',

  'admin.tutors.links.show' : 'Show tutor links',
  'admin.tutors.links.update' : 'Tutor links was updated',

  'admin.tutors.rates.show' : 'Show tutor rates',
  'admin.tutors.rates.update' : 'Tutor rates was updated',

  'admin.tutor-schedule.demo-slots.index' : 'List demo slots in tutor schedule',
  'admin.tutor-schedule.demo-slots.show' : 'Show demo slot details',
  'admin.tutor-schedule.demo-slots.set-priority' : 'Set demo slot priority',

  'admin.tutor-schedule.analytics.index' : 'View tutor schedule analytics',

  'admin.tutor-schedule.requests.index' : 'List tutor schedule requests',
  'admin.tutor-schedule.requests.update' : 'Tutor schedule request was updated',
  'admin.tutor-schedule.requests.update-bulk' : 'Bulk tutor schedule requests was updated',

  'admin.tutor-schedule.settings.index' : 'View tutor schedule settings',
  'admin.tutor-schedule.settings.update' : 'Tutor schedule settings was updated',

  'admin.tutor-slots.index' : 'List tutor slots',
  'admin.tutor-slots.export' : 'Export tutor slots',
  'admin.tutor-slots.store' : 'Tutor slot was created',
  'admin.tutor-slots.show' : 'Tutor slot was shown',
  'admin.tutor-slots.update' : 'Tutor slot was updated',
  'admin.tutor-slots.delete' : 'Delete tutor slot',

  'admin.tutor-schedule.day' : 'View tutor schedule day',
  'admin.tutor-schedule.week' : 'View tutor schedule week',
  'admin.tutor-schedule.unavailable' : 'Mark tutor schedule as unavailable',
  'admin.tutor-schedule.available' : 'Mark tutor slot as available',
  'admin.tutor-schedule.availability' : 'Get tutors availability',

  'admin.newsletters.index' : 'List newsletters',
  'admin.newsletters.store' : 'Newsletter was created',
  'admin.newsletters.create' : 'Show newsletter creation form',
  'admin.newsletters.show' : 'Show newsletter',
  'admin.newsletters.update' : 'Newsletter was updated',
  'admin.newsletters.delete' : 'Delete newsletter',
  'admin.newsletters.validate-sender' : 'Validate custom newsletter template',

  'admin.newsletter-logs.index' : 'View newsletter logs',

  'admin.changelog.index' : 'View changelog',
  'admin.changelog.show' : 'View specific changelog action',
  'admin.changelog.discipline' : 'View discipline changelog',
  'admin.changelog.customer' : 'View customer changelog',
  'admin.changelog.subscription' : 'View subscription changelog',
  'admin.changelog.booking' : 'View booking changelog',

  'admin.orders.index' : 'List orders',
  'admin.orders.show' : 'Show order',
  'admin.orders.send' : 'Send order',
  'admin.orders.sync' : 'Sync order',
  'admin.orders.retry' : 'Retry order',

  'admin.promocodes.index' : 'List promocodes',
  'admin.promocodes.create' : 'Promocode was created',
  'admin.promocodes.update' : 'Promocode was updated',

  'admin.users.index' : 'List users',
  'admin.users.show' : 'User was showed',
  'admin.users.store' : 'User was updated',
  'admin.users.delete' : 'Delete user',

  'admin.api-tokens.index' : 'List API tokens',
  'admin.api-tokens.store' : 'API token was created',
  'admin.api-tokens.delete' : 'API token was deleted',
  'admin-api.api-tokens.index' : 'List API tokens',
  'admin-api.api-tokens.store' : 'API token was created',
  'admin-api.api-tokens.update' : 'API token was updated',
  'admin-api.api-tokens.destroy' : 'API token was revoked',

  'admin.profile.edit' : 'Edit profile',
  'admin.profile.update' : 'Profile was updated',
  'admin.password.update' : 'Admin password was updated',

  'admin.settings.update' : 'Settings was updated',
  'admin.settings.delete' : 'Delete setting',

  'admin-api.oauth.index' : 'View OAuth settings',
  'admin-api.oauth.delete' : 'Delete OAuth setting',
  'admin.oauth.zoho' : 'OAuth Zoho action',
  'admin.oauth.google' : 'OAuth Google action',

  'admin.tests.index' : 'List tests was showed',

  'admin.kanban.service' : 'View Kanban service',
  'admin.kanban.upgrade' : 'View Kanban upgrade',
  'admin.kanban.billing' : 'View Kanban billing',
  'admin.kanban.export' : 'Export Kanban',
  'admin.kanban.show' : 'Kanban discipline was showed',
  'admin.kanban.update' : 'Kanban discipline was updated',
  'admin.kanban.show-logs' : 'Kanban logs was showed',

  'admin.kanban.comments.index' : 'List Kanban comments',
  'admin.kanban.comments.store' : 'Kanban comment was created',
  'admin.kanban.comments.update' : 'Kanban comment was updated',
  'admin.kanban.comments.destroy' : 'Delete Kanban comment',

  'admin-api.tutor-kanban.onboarding' : 'View Kanban onboarding',
  'admin-api.tutor-kanban.active' : 'View Kanban active',
  'admin-api.tutor-kanban.probation' : 'View Kanban probation',
  'admin-api.tutor-kanban.export' : 'Export Kanban',
  'admin-api.tutor-kanban.show' : 'Kanban tutor was showed',
  'admin-api.tutor-kanban.update' : 'Kanban tutor was updated',
  'admin-api.tutor-kanban.show-logs' : 'Kanban logs was showed',

  'admin-api.tutor-kanban.comments.index' : 'List Kanban comments',
  'admin-api.tutor-kanban.comments.store' : 'Kanban comment was created',
  'admin-api.tutor-kanban.comments.update' : 'Kanban comment was updated',
  'admin-api.tutor-kanban.comments.destroy' : 'Delete Kanban comment',

  'admin.teams.index' : 'List teams was showed',
  'admin.teams.show' : 'Team page was showed',
  'admin.teams.store' : 'Team page was created',
  'admin.teams.update' : 'Team page was updated',
  'admin.teams.destroy' : 'Delete team',

  'admin.tutor-tasks.analytics.index' : 'View tutor tasks analytics',
  'admin.tutor-tasks.analytics.export' : 'Export tutor tasks analytics',

  'admin.tutor-tasks.index' : 'List tutor tasks',
  'admin.tutor-tasks.export' : 'Export tutor tasks',
  'admin.tutor-tasks.show' : 'Show tutor task',
  'admin.tutor-tasks.store' : 'Tutor task was created',
  'admin.tutor-tasks.update' : 'Tutor task was updated',
  'admin.tutor-tasks.destroy' : 'Delete tutor task',
  'admin.tutor-tasks.postpone-dates' : 'Show postpone dates for task',
  'admin.tutor-tasks.postpone' : 'Postpone task dates',

  'tutor.autologin' : 'Auto-login to lesson',

  'tutor.register' : 'Tutor registration form',
  'tutor.login' : 'Tutor login form',
  'tutor.password.request' : 'Request password was reset',
  'tutor.password.email' : 'Password reset was sent to email',
  'tutor.password.reset' : 'Password form was reset',
  'tutor.password.update' : 'Tutor password was updated',
  'tutor.welcome' : 'Welcome page',

  'tutor.dashboard.index' : 'Tutor dashboard was showed',

  'tutor.lesson.index' : 'List tutor lessons was showed',
  'tutor.lesson.finish' : 'Finish lesson',
  'tutor.lesson.remind' : 'Remind about lesson',
  'tutor.lesson.voip-technical-issue' : 'Report VOIP technical issue',
  'tutor.lesson.ping' : 'Ping lesson',
  'tutor.lesson.available-tutors' : 'List available tutors',
  'tutor.lesson.cancel' : 'Cancel lesson',
  'tutor.lesson.reschedule' : 'Reschedule lesson',
  'tutor.lesson.technical-issue' : 'Report lesson technical issue',

  'tutor.attendance-rates.index' : 'Tutor attendance rates was viewed',

  'tutor.bookings.index' : 'Bookings calendar was viewed',
  'tutor.bookings.update' : 'Booking was updated',

  'tutor.bookings.recording.start' : 'Booking recording was started',

  'tutor.tasks.index' : 'List tutor tasks was showed',
  'tutor.tasks.show' : 'Tutor task was showed',
  'tutor.tasks.complete' : 'Tutor task was completed',
  'tutor.tasks.postpone-dates' : 'Postpone dates for task was showed',
  'tutor.tasks.postpone' : 'Postpone task was showed',
  'tutor.tasks.cancel' : 'Task was canceled',

  'tutor.slots.index' : 'List slots was showed',
  'tutor.slots.show' : 'Slot was showed',
  'tutor.slots.store' : 'Slot was created',
  'tutor.slots.delete' : 'Slot was deleted',

  'tutor.schedule.current' : 'Current schedule was viewed',
  'tutor.schedule.next' : 'Next schedule was viewed',
  'tutor.schedule.confirm.next' : 'Next schedule was confirmed',
  'tutor.schedule.confirm.current' : 'Current schedule was confirmed',
  'tutor.schedule.unavailable' : 'Mark schedule unavailable',
  'tutor.schedule.available' : 'Mark slot available',

  'tutor.profile.show' : 'Tutor profile was showed',
  'tutor.profile.update' : 'Tutor profile was updated',
  'tutor.profile.schedule' : 'Tutor schedule in profile was viewed',
  'tutor.profile.update-schedule' : 'Tutor schedule in profile was updated',

  'tutor.files.upload' : 'File was uploaded',
  'tutor.files.delete' : 'File was deleted',
  'tutor.bookings.certificate' : 'Certificate was generated',
  'tutor.files.index' : 'List inbox files was showed',
  'tutor.files.create' : 'File pack on tutor area was created',
  'tutor.files.sent' : 'List sent files was showed',
  'tutor.files.show' : 'File pack was shown',
  'tutor.files.edit' : 'File pack was edited',
  'tutor.files.send' : 'File pack was sent',
  'tutor.files.delete-pack' : 'File pack was deleted',

  'tutor.logout' : 'Tutor logout',

  'tutor.request.send' : 'Tutor request was sent',

  'tutor.disciplines.index' : 'All paid students was showed',
  'tutor.disciplines.show' : 'Paid student was showed',
  'tutor.disciplines.update' : 'Paid student was updated',
  'tutor.disciplines.demo-report' : 'Student\'s demo report  was viewed',
  'tutor.disciplines.bookings' : 'Student bookings was viewed',
  'tutor.disciplines.files' : 'Student files was viewed',
  'tutor.disciplines.files.sent' : 'Student files was sent',
  'tutor.disciplines.tasks' : 'Student tasks was viewed',

  'customer-api.disciplines.track.home': 'Dashboard was visited',
  'customer-api.discipline.update': 'Discipline was updated',
  'customer-api.disciplines.bookings.schedule': 'Booking was scheduled',
  'customer-api.disciplines.skill-report': 'Skill Report was visited',
  'customer-api.pad.math.products': 'Math Pad was visited',
  'customer-api.subscriptions.store': 'Subscription was created',
  'customer-api.pricing.math.products': 'Math Pricing was visited',
  'customer-api.pricing.ela.products': 'Ela Pricing was visited',
  'customer-api.me.settings.update': 'User settings was updated',
  'customer-api.disciplines.tutor-change-requests.store': 'Tutor request was created',
  'customer-api.me.update': 'User profile was updated',
  'customer-api.disciplines.activation.activate': 'Discipline Activation was activated',
  'customer-api.bookings.demo-book': 'Demo booking was created',
  'customer-api.disciplines.files.upload': 'Discipline files were uploaded',
  'customer-api.bookings.ping': 'Waiting room',
  'customer-api.pad.ela.products': 'Ela Pad was visited',
  'customer-api.me.show': 'Dashboard was visited',
}
